import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { QcsButton } from './basic/QcsButton';
import { QcsDialog } from './basic/QcsDialog';
import { QcsDialogActions } from './basic/QcsDialogActions';
import { DialogContent, DialogTitle } from '@mui/material';

import { QcsDialogContentText } from './basic/QcsDialogContentText';

interface Props {
  onClose: () => void;
  onConfirm: (() => void) | null;
  title?: string | null;
  message?: ReactNode | string;
  confirmMessage?: string;
  cancelText?: string;
}

export const ConfirmDialog: FC<Props> = ({ title, message, confirmMessage, cancelText, onClose, onConfirm }) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <QcsDialog open={!!onConfirm} onClose={onClose}>
      <DialogTitle>{title ?? t('common.confirmDialog.title')}</DialogTitle>
      <DialogContent>
        <QcsDialogContentText>{message ?? t('common.confirmDialog.message')}</QcsDialogContentText>
      </DialogContent>
      <QcsDialogActions>
        <QcsButton onClick={onClose}>{confirmMessage ?? t('common.confirmDialog.cancel')}</QcsButton>
        <QcsButton onClick={handleConfirm}>{cancelText ?? t('common.confirmDialog.confirm')}</QcsButton>
      </QcsDialogActions>
    </QcsDialog>
  );
};
